/**
 * Référentiel MITRE ATT&CK Enterprise, sous-ensemble utilisé par MiniSOC.
 *
 * Source de vérité fonctionnelle : les tags MITRE portés par les règles SIGMA
 * (§5.3.1). Cette table sert uniquement à afficher des libellés lisibles et à
 * construire la heatmap du dashboard KPI sans dépendre d'un appel réseau vers
 * attack.mitre.org.
 */
export const MitreTactic = {
    INITIAL_ACCESS: 'TA0001',
    EXECUTION: 'TA0002',
    PERSISTENCE: 'TA0003',
    PRIVILEGE_ESCALATION: 'TA0004',
    DEFENSE_EVASION: 'TA0005',
    CREDENTIAL_ACCESS: 'TA0006',
    DISCOVERY: 'TA0007',
    LATERAL_MOVEMENT: 'TA0008',
    COLLECTION: 'TA0009',
    COMMAND_AND_CONTROL: 'TA0011',
    EXFILTRATION: 'TA0010',
    IMPACT: 'TA0040',
};
export const MITRE_TACTICS = [
    { id: 'TA0001', name: 'Initial Access', nameFr: 'Accès initial' },
    { id: 'TA0002', name: 'Execution', nameFr: 'Exécution' },
    { id: 'TA0003', name: 'Persistence', nameFr: 'Persistance' },
    { id: 'TA0004', name: 'Privilege Escalation', nameFr: 'Élévation de privilèges' },
    { id: 'TA0005', name: 'Defense Evasion', nameFr: 'Contournement des défenses' },
    { id: 'TA0006', name: 'Credential Access', nameFr: 'Accès aux identifiants' },
    { id: 'TA0007', name: 'Discovery', nameFr: 'Découverte' },
    { id: 'TA0008', name: 'Lateral Movement', nameFr: 'Déplacement latéral' },
    { id: 'TA0009', name: 'Collection', nameFr: 'Collecte' },
    { id: 'TA0010', name: 'Exfiltration', nameFr: 'Exfiltration' },
    { id: 'TA0011', name: 'Command and Control', nameFr: 'Commande et contrôle' },
    { id: 'TA0040', name: 'Impact', nameFr: 'Impact' },
];
/** Techniques couvertes par le catalogue Red Flag du MVP (§5.3.3). */
export const MITRE_TECHNIQUES = [
    { id: 'T1078', name: 'Valid Accounts', tactics: ['TA0001', 'TA0003', 'TA0004', 'TA0005'] },
    { id: 'T1078.002', name: 'Valid Accounts: Domain Accounts', tactics: ['TA0003', 'TA0004'] },
    { id: 'T1098', name: 'Account Manipulation', tactics: ['TA0003'] },
    {
        id: 'T1070.001',
        name: 'Indicator Removal: Clear Windows Event Logs',
        tactics: ['TA0005'],
    },
    { id: 'T1110.001', name: 'Brute Force: Password Guessing', tactics: ['TA0006'] },
    { id: 'T1110.003', name: 'Brute Force: Password Spraying', tactics: ['TA0006'] },
    { id: 'T1200', name: 'Hardware Additions', tactics: ['TA0001'] },
    { id: 'T1059', name: 'Command and Scripting Interpreter', tactics: ['TA0002'] },
    { id: 'T1204', name: 'User Execution', tactics: ['TA0002'] },
    {
        id: 'T1562.001',
        name: 'Impair Defenses: Disable or Modify Tools',
        tactics: ['TA0005'],
    },
];
const TACTICS_BY_ID = new Map(MITRE_TACTICS.map((tactic) => [tactic.id, tactic]));
const TECHNIQUES_BY_ID = new Map(MITRE_TECHNIQUES.map((technique) => [technique.id, technique]));
export const findMitreTactic = (id) => TACTICS_BY_ID.get(id);
export const findMitreTechnique = (id) => TECHNIQUES_BY_ID.get(id);
/** URL de documentation officielle d'une technique, pour les liens du dashboard. */
export function mitreTechniqueUrl(id) {
    return `https://attack.mitre.org/techniques/${id.replace('.', '/')}/`;
}
//# sourceMappingURL=mitre.js.map